import React, { useState, useEffect, useRef } from "react";
import styles from "./guilds-modal.module.css";
import Input from "../../ui/input";
import { MyIcons } from "../../icons/my-icons";
import Button from "../../ui/button";
import Table from "../../ui/table";
import { getGuilds, createGuild, editGuild } from "../../../services/apiService";

const GuildsModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);
  const firstInputRef = useRef(null);
  const [formData, setFormData] = useState({
    name: "",
  });
  const [guilds, setGuilds] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingGuildId, setEditingGuildId] = useState(null);

  useEffect(() => {
    const fetchGuilds = async () => {
      try {
        const guildsData = await getGuilds();
        setGuilds(guildsData);
      } catch (error) {
        console.error("Error fetching guilds:", error);
      }
    };

    if (isOpen) {
      fetchGuilds();
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddGuild = async () => {
    try {
      const guildData = {
        nombre: formData.name
      };

      if (isEditMode && editingGuildId) {
        // Modo edición
        await editGuild(editingGuildId, guildData);
        console.log("Gremio editado exitosamente");
      } else {
        // Modo creación
        await createGuild(guildData);
        console.log("Gremio creado exitosamente");
      }
      
      // Refrescar la lista de gremios
      const guildsData = await getGuilds();
      setGuilds(guildsData);
      
      // Limpiar el formulario y resetear modo edición
      setFormData({
        name: ""
      });
      setIsEditMode(false);
      setEditingGuildId(null);
    } catch (error) {
      console.error("Error al guardar gremio:", error);
    }
  };

  const handleGuildClick = (guild) => {
    setFormData({
      name: guild.nombre
    });
    setIsEditMode(true);
    setEditingGuildId(guild.id);
    
    // Hacer scroll al inicio del modal y focus en el primer input
    setTimeout(() => {
      if (modalRef.current) {
        modalRef.current.scrollTop = 0;
      }
      if (firstInputRef.current) {
        firstInputRef.current.focus();
      }
    }, 100);
  };

  const handleCancel = () => {
    setFormData({
      name: ""
    });
    setIsEditMode(false);
    setEditingGuildId(null);
  };

  const headers = [
    { label: "Nombre", key: "nombre" },
  ];

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer} ref={modalRef}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>Gremios</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <MyIcons
              name="close"
              width={24}
              height={24}
              color="black"
            />
          </button>
        </div>

        <div className={styles.formSection}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              width: "100%",
            }}
          >
            <Input
              ref={firstInputRef}
              label="Nombre"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              style={{ flex: 1 }}
            />
          </div>
        </div>

        <div style={{ marginBottom: "16px", display: "flex", gap: "12px" }}>
          <Button type="button" variant="primary" onClick={handleAddGuild}>
            {isEditMode ? "GUARDAR CAMBIOS" : "AÑADIR GREMIO"}
          </Button>
          {isEditMode && (
            <Button type="button" variant="secondary" onClick={handleCancel}>
              CANCELAR
            </Button>
          )}
        </div>

        <div className={styles.tableSection}>
          <Table headers={headers} data={guilds} onPress={handleGuildClick} />
        </div>
      </div>
    </div>
  );
};

export default GuildsModal;
